import { ColumnListDto } from "@common/dto/column/list-dto";
import { HttpSuccessDto } from "@common/dto/http";
import { PedigreeListDto } from "@common/dto/pedigree/list-dto";
import { clientTransformed } from "@common/utils/rest";

export type GetPedigreesRequestFiltering = {
  search?: string;
  filterApplied: boolean;
  columnFilters: {};
  columns: Array<ColumnListDto>;
};

export type GetPedigreesRequestPagination = {
  start: number;
  size: number;
};

export type GetPedigreesRequestParams = {
  filtering: GetPedigreesRequestFiltering;
  pagination: GetPedigreesRequestPagination;
};

export const getPedigrees = ({ filtering, pagination }: GetPedigreesRequestParams): Promise<{ data: Array<PedigreeListDto>; totalCount: number; }> => {
	return clientTransformed({
    path: 'api/pedigree/smartlist',
    method: 'POST',
		entity: {
			...filtering,
			...pagination,
		},
  }).then(
    (response: HttpSuccessDto<{ data: Array<PedigreeListDto>; totalCount: number; }>) => {
      return response.entity;
    },
  );
};